import React, { ReactNode } from 'react';
import { styled } from '@linaria/react';
type Props = {
  rightSlot?: ReactNode;
  leftSlot?: ReactNode;
};
const Container = /*#__PURE__*/styled('div')({
  name: "Container",
  class: "ced4yel",
  propsAsIs: false
});
const Side = /*#__PURE__*/styled('div')({
  name: "Side",
  class: "s1glg0zc",
  propsAsIs: false
});
export const AccommodationFloatingHeader = ({
  rightSlot,
  leftSlot
}: Props) => {
  if (!rightSlot && !leftSlot) {
    throw new Error('At least one of rightSlot or leftSlot must be provided.');
  }
  return <Container>
      {rightSlot && <Side className="--right-aligned">{rightSlot}</Side>}
      {leftSlot && <Side className="--left-aligned">{leftSlot}</Side>}
    </Container>;
};

require("./AccommodationFloatingHeader.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./AccommodationFloatingHeader.tsx");